import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

import createAuthSlice, { AuthSlice } from "./slices/createAuthSlice";

const useStore = create<AuthSlice>()(
  persist(
    createAuthSlice,
    {
      name: "user",
      storage: createJSONStorage(() => localStorage),

      // jangan persist isLoading
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useStore;
